<template>
    <div style="width: 100%;padding: 20px;box-sizing: border-box;">
        <div style="display: flex;align-items: center;">
            <div style="flex: 1;">
                <el-button
                    v-if="userType === 'advisor'"
                    type="primary"
                    size="small"
                    @click="navigateToApplications"
                    style="margin-right: auto;"
                >
                    Membership Applications
                </el-button>
            </div>
            <div style="flex: 1;display: flex;flex-direction: row-reverse;align-items: center;gap: 10px;">
                <template v-if="canManageStudents">
                    <el-upload class="upload-demo" action="#" :limit="1" :before-upload="beforeFileUpload">
                        <el-button slot="trigger" size="small" type="primary">Import</el-button>
                    </el-upload>
                    <el-button type="primary" size="small" style="width: 80px;"
                        @click="initAddStudentInfo()">Add</el-button>
                    <el-button type="primary" size="small"
                        @click="showShareDialog = true">Share Application Form to Students</el-button>
                </template>
                <template v-if="!isStudent">
                    <template v-if="!batchEditMode">
                        <el-button type="warning" size="small" @click="enterBatchEditMode">Batch Edit</el-button>
                    </template>
                    <template v-else>
                        <el-button size="small" @click="exitBatchEditMode">Cancel</el-button>
                        <el-button type="primary" size="small" @click="batchSetDate('end')">Set End Date</el-button>
                        <el-button type="primary" size="small" @click="batchSetDate('start')">Set Start Date</el-button>
                    </template>
                </template>
            </div>
        </div>

        <el-table
            :data="dataList"
            style="margin-top: 20px;"
            empty-text="No Data"
            :highlight-current-row="false"
            :highlight-selection-row="false"
            :header-cell-class-name="'custom-head-cell'"
            :row-class-name="'custom-row-bg'"
            ref="memberTable"
            @selection-change="handleSelectionChange">
            <el-table-column
                v-if="batchEditMode"
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column prop="name" label="Student Name">
                <template slot-scope="scope">
                    <div v-if="scope.row.user">{{ scope.row.user.student_lastName_pinyin &&
                        scope.row.user.student_givenName_pinyin ? scope.row.user.student_givenName_pinyin + ' ' +
                    scope.row.user.student_lastName_pinyin : (scope.row.user.student_givenName + ' ' +
                        scope.row.user.student_lastName) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="user.student_email" label="Email">
            </el-table-column>
            <el-table-column prop="user.student_grade" label="Grade" width="80">
            </el-table-column>
            <el-table-column prop="user_role" label="Role" width="100">
                <template slot-scope="scope">
                    <span :class="['role-tag', isLeaderRole(scope.row.user_role) ? 'role-tag--leader' : 'role-tag--member']">
                        {{ capitalizeEachWord(scope.row.user_role) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="Start Date" width="160">
                <template slot-scope="scope">
                    <el-date-picker
                        v-if="scope.row._editingStartDate && !isStudent"
                        v-model="scope.row.membership_start"
                        type="date"
                        placeholder="Start date"
                        value-format="yyyy-MM-dd"
                        size="small"
                        style="width: 130px;"
                        @change="saveMembershipDate(scope.row, 'start')"
                        @blur="scope.row._editingStartDate = false">
                    </el-date-picker>
                    <span v-else :style="!isStudent ? 'cursor: pointer;' : ''" @click="!isStudent && $set(scope.row, '_editingStartDate', true)">
                        {{ scope.row.membership_start || '-' }}
                        <i v-if="!isStudent" class="el-icon-edit" style="color: #409eff; margin-left: 4px;"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="End Date" width="160">
                <template slot-scope="scope">
                    <el-date-picker
                        v-if="scope.row._editingEndDate && !isStudent"
                        v-model="scope.row.membership_end"
                        type="date"
                        placeholder="End date"
                        value-format="yyyy-MM-dd"
                        size="small"
                        style="width: 130px;"
                        @change="saveMembershipDate(scope.row, 'end')"
                        @blur="scope.row._editingEndDate = false">
                    </el-date-picker>
                    <span v-else :style="!isStudent ? 'cursor: pointer;' : ''" @click="!isStudent && $set(scope.row, '_editingEndDate', true)">
                        {{ scope.row.membership_end || '-' }}
                        <i v-if="!isStudent" class="el-icon-edit" style="color: #409eff; margin-left: 4px;"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="Operation" width="380px">
                <template slot-scope="scope">
                    <template v-if="!isStudent">
                        <el-button type="primary" size="small" @click="showManagePositions(scope.row)">
                            Manage Positions
                        </el-button>
                    </template>
                    <el-button
                        v-if="!isStudent || isCurrentStudentRow(scope.row)"
                        :disabled="!canViewCertificate(scope.row)"
                        :type="canViewCertificate(scope.row) ? 'success' : 'info'"
                        size="small"
                        @click="viewCertificate(scope.row)">
                        Certificate
                    </el-button>
                    <el-dropdown v-if="!isStudent" trigger="click">
                        <span class="el-dropdown-link" style="cursor: pointer; padding: 8px; display: inline-block;">
                            <i class="el-icon-more" style="font-size: 20px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="retireStudent(scope.row._id.$id)">
                                <span style="color: #f56c6c;">Retire Student</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :visible.sync="showAddStudentDialog" title="Add Student" width="46%">
            <div>
                <el-form :model="addStudentInfo" ref="form" :rules="rules" label-position="right" label-width="95px">
                    <div style="display: flex;">
                        <el-form-item label="First Name" style="flex: 1;" prop="givenName_pinyin">
                            <el-input v-model="addStudentInfo.givenName_pinyin" placeholder="Please input"></el-input>
                        </el-form-item>
                        <el-form-item label="Last Name" style="flex: 1;" prop="lastName_pinyin">
                            <el-input v-model="addStudentInfo.lastName_pinyin" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                    <div style="display: flex;">
                        <el-form-item label="Email" style="flex: 1;" prop="email">
                            <el-input v-model="addStudentInfo.email" placeholder="Please input"></el-input>
                        </el-form-item>
                        <el-form-item label="Gender" style="flex: 1;" prop="gender">
                            <el-radio-group v-model="addStudentInfo.gender">
                                <el-radio label="male">Male</el-radio>
                                <el-radio label="female">Female</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div style="display: flex;">
                        <el-form-item label="Grade" style="flex: 1;" prop="grade">
                            <el-select v-model="addStudentInfo.grade" placeholder="Please select"
                style="width: 100%;"
                >
                                <el-option v-for="(name, index) in 6" :key="index" :label="name + 6"
                                    :value="name + 5"></el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="Role" style="flex: 1;" prop="user_role">
                            <el-radio-group v-model="addStudentInfo.user_role">
                                <el-radio label="leader">Leader</el-radio>
                                <el-radio label="member">Member</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </el-form>
                <div style="text-align: right;">
                    <el-button @click="showAddStudentDialog = false">Cancel</el-button>
                    <el-button type="primary" @click="doAddStudentToClub">Confirm</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showPositionsDialog" title="Manage Positions" width="40%">
            <el-form :model="positionsForm" label-width="100px">
                <el-form-item label="Positions">
                    <el-checkbox-group v-model="positionsForm.selectedPositions">
                        <el-checkbox
                            v-for="position in availablePositions"
                            :key="position"
                            :label="position">
                            {{ position }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div style="text-align: right;">
                <el-button @click="showPositionsDialog = false">Cancel</el-button>
                <el-button type="primary" @click="savePositions">Save</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showShareDialog" title="Share Application Form" width="500px">
            <div>
                <p>Share this link with students to let them apply for the club:</p>
                <el-input
                    v-model="applicationLink"
                    readonly
                    style="margin: 10px 0;">
                    <el-button slot="append" @click="copyLink">Copy</el-button>
                </el-input>
            </div>
            <div style="text-align: right;">
                <el-button @click="showShareDialog = false">Close</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="showBatchDateDialog"
            :title="batchDateType === 'start' ? 'Set Start Date' : 'Set End Date'"
            width="400px">
            <div>
                <p>Set {{ batchDateType === 'start' ? 'Start Date' : 'End Date' }} for {{ batchSelectedRows.length }} selected student(s):</p>
                <el-date-picker
                    v-model="batchDateValue"
                    type="date"
                    placeholder="Select date"
                    value-format="yyyy-MM-dd"
                    style="width: 100%;">
                </el-date-picker>
            </div>
            <div style="text-align: right; margin-top: 20px;">
                <el-button @click="showBatchDateDialog = false">Cancel</el-button>
                <el-button type="primary" @click="confirmBatchDate">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getClubInfo,
    retireStudentFromClub,
    addStudentToClub,
    getStudentsByAccount,
    getClubStudents,
    postRequest,
} from '../../api/eclub'
import {
    getAccountId,
    getUserType,
    getUserId,
    getUserEmail
} from '../../utils/store'
import * as XLSX from "xlsx";

export default {
    name: 'ClubStudents',
    props: {
        club_id: {
            type: String,
            required: true
        },
        clubInfo: {
            type: Object,
            required: true
        },
        activeTab: {
            type: String,
            default: ''
        }
    },
    watch: {
        activeTab(val) {
            if (val === 'members') {
                this.fetchData();
            }
        }
    },
    data() {
        return {
            user_id: getUserId(),
            userType: getUserType(),
            currentUserEmail: getUserEmail(),
            dataList: [],
            student_list: [],
            select_student_id: '',
            addStudentInfo: {
                account_id: getAccountId(),
                project_code: 'EClub',
                email: '',
                lastName_pinyin: '',
                givenName_pinyin: '',
                grade: '',
                club_id: '',
                added_from: '',
                added_from_id: '',
                user_role: 'member',
                gender: ''
            },

            rules: {
                email: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                lastName_pinyin: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                givenName_pinyin: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                grade: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                gender: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                user_role: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
            },

            showAddStudentDialog: false,
            showPositionsDialog: false,
            positionsForm: {
                selectedPositions: [],
                studentId: null
            },
            showShareDialog: false,
            applicationLink: '',
            batchEditMode: false,
            batchSelectedRows: [],
            showBatchDateDialog: false,
            batchDateType: '',
            batchDateValue: '',
            tableLoading: false,
        }
    },
    computed: {
        availablePositions() {
            const positions = []
            if (this.clubInfo?.positions) {
                positions.push(...this.clubInfo.positions)
            }
            if (this.clubInfo?.leadership) {
                this.clubInfo.leadership.forEach(l => {
                    const name = l.position || l.name
                    if (name && !positions.includes(name)) {
                        positions.push(name)
                    }
                })
            }
            return positions
        },
        isStudent() {
            return this.userType === 'student'
        },
        currentStudentRow() {
            if (!this.isStudent) return null
            return this.dataList.find(row => {
                if (!row || !row.user) return false
                if (row.user_id && row.user_id === this.user_id) return true
                if (row.user.student_email && this.currentUserEmail &&
                    row.user.student_email.toLowerCase() === this.currentUserEmail.toLowerCase()) return true
                return false
            }) || null
        },
        isCurrentStudentLeader() {
            const row = this.currentStudentRow
            return !!row && this.isLeaderRole(row.user_role)
        },
        canManageStudents() {
            // Advisors and school admins always can manage; students can manage
            // only if they are leaders of this club.
            if (!this.isStudent) return true
            return this.isCurrentStudentLeader
        }
    },
    created() {
        this.addStudentInfo.club_id = this.club_id;
        this.applicationLink = `${window.location.origin}/#/schoolclubprofile?club_id=${this.club_id}`;
    },
    mounted() {
        this.user_id = getUserType() === 'advisor' ? getUserId() : getAccountId();
        this.fetchData();
        this.requestStudents();
    },
    methods: {
        capitalizeEachWord (str) {
            if (typeof str !== 'string' || str.length === 0) {
                return str; // 如果输入不是字符串或为空字符串，则直接返回
            }
            return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        },
        isLeaderRole(role) {
            return typeof role === 'string' && role.toLowerCase() === 'leader'
        },
        isCurrentStudentRow(row) {
            const cur = this.currentStudentRow
            if (!cur || !row) return false
            return cur === row || (row._id && cur._id && row._id.$id === cur._id.$id)
        },

        initAddStudentInfo() {
            this.addStudentInfo = {
                account_id: getAccountId(),
                project_code: 'EClub',
                email: '',
                lastName_pinyin: '',
                givenName_pinyin: '',
                grade: '',
                club_id: this.club_id,
                added_from: getUserType(),
                added_from_id: getUserId(),
                user_role: 'member',
                gender: '',

            }
            this.showAddStudentDialog = true
        },

        doAddStudentToClub() {
            this.$refs.form.validate((val) => {
                if (val) {
                    addStudentToClub(this.addStudentInfo).then((res) => {
                        this.$message.success('Add successful')
                        this.fetchData()
                        this.showAddStudentDialog = false
                    })
                }
            })
        },

        requestStudents() {
            getStudentsByAccount(this.user_id, getUserType()).then((res) => {
                this.student_list = res.data.data
            })
        },

        gotoShowClubStudents(club_id) {
            this.$router.push({
                path: '/home/clubstudents',
                query: {
                    club_id: club_id
                }
            })
        },

        fetchData() {
            this.tableLoading = true
            getClubStudents(this.club_id).then((res) => {
                this.dataList = res.data.data
            }).finally(() => {
                this.tableLoading = false
            })
        },
        retireStudent(club_user_id) {
            this.$alert('Are you sure you want to retire the student from this club?', 'Retire Student', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                callback: action => {
                    if (action == 'confirm') {
                        retireStudentFromClub(club_user_id).then((res) => {
                            this.$message.success('Student retired successfully')
                            this.fetchData()
                        })
                    }
                }
            })
        },
        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: GravityBold;'
        },
        beforeFileUpload(file) {
            const reader = new FileReader()
            let that = this
            reader.onload = e => {
                const data = e.target.result
                const workbook = XLSX.read(data, { type: 'array' })
                const secondSheet = workbook.SheetNames[0]
                const worksheet = workbook.Sheets[secondSheet]
                const results = XLSX.utils.sheet_to_json(worksheet)
                let dataList = []
                var length = results.length
                for (let i = 0; i < length; i++) {
                    let content = results[i]
                    let First_Name = content['First_Name']
                    let Last_Name = content['Last_Name']
                    let Email = content['Email']
                    let Grade = content['Grade']
                    let params = {
                        account_id: getAccountId(),
                        project_code: 'EClub',
                        email: Email,
                        lastName_pinyin: Last_Name,
                        givenName_pinyin: First_Name,
                        grade: Grade,
                        club_id: this.club_id,
                        added_from: getUserType(),
                        added_from_id: getUserId(),
                        user_role: 'member'
                    }
                    addStudentToClub(params).then((res) => {
                    })
                    // console.log('params :' + JSON.stringify(params))
                    if (i == (length - 1)) {
                        that.$message.success('Import successful.')
                        that.fetchData()
                    }
                }
            }
            reader.readAsArrayBuffer(file)
        },
        showManagePositions(student) {
            if (this.availablePositions.length === 0) {
                this.$message({
                    message: 'This club does not have any positions set up. Please configure club positions first.',
                    type: 'warning'
                });
                return;
            }

            this.positionsForm.studentId = student._id.$id;
            this.positionsForm.selectedPositions = student.positions || [];
            this.showPositionsDialog = true;
        },

        savePositions() {
            postRequest('updateStudentPositions', {
                club_user_id: this.positionsForm.studentId,
                club_id: this.club_id,
                positions: this.positionsForm.selectedPositions
            }).then((res) => {
                if (res.data.code === 0) {
                    this.$message.success('Positions updated successfully');
                    this.showPositionsDialog = false;
                    this.fetchData();
                    this.$emit('refresh-club');
                } else {
                    this.$message.error(res.data.message || 'Failed to update positions');
                }
            }).catch(() => {
                this.$message.error('Failed to update positions');
            });
        },
        copyLink() {
            navigator.clipboard.writeText(this.applicationLink)
                .then(() => {
                    this.$message.success('Link copied to clipboard');
                })
                .catch(() => {
                    this.$message.error('Failed to copy link');
                });
        },
        navigateToApplications() {
            this.$emit('change-tab', 'Applications');
        },
        canViewCertificate(row) {
            // Certificate is only available when End Date is set and current date > End Date
            if (!row.membership_end) return false
            const today = new Date().toISOString().split('T')[0]
            return today > row.membership_end
        },
        viewCertificate(row) {
            if (!row.user || !this.canViewCertificate(row)) return
            if (this.isStudent && !this.isCurrentStudentRow(row)) return

            const userName = row.user.student_givenName_pinyin && row.user.student_lastName_pinyin
                ? `${row.user.student_givenName_pinyin} ${row.user.student_lastName_pinyin}`
                : `${row.user.student_givenName || ''} ${row.user.student_lastName || ''}`
            const schoolName = this.clubInfo.account_nameEN || this.clubInfo.account_name || ''

            const route = this.$router.resolve({
                path: '/certificate',
                query: {
                    type: 'membership',
                    club_name: this.clubInfo.name,
                    school_name: schoolName,
                    user_name: userName.trim(),
                    user_email: row.user.student_email || '',
                    tenure_start: row.membership_start || '',
                    tenure_end: row.membership_end || ''
                }
            })
            window.open(route.href, '_blank')
        },
        saveMembershipDate(row, dateType) {
            // Validate: end date must not be earlier than start date
            if (row.membership_start && row.membership_end && row.membership_end < row.membership_start) {
                this.$message.warning('End Date cannot be earlier than Start Date')
                return
            }
            const field = dateType === 'start' ? 'membership_start' : 'membership_end'
            postRequest('updateClubStudentMembership', {
                club_user_id: row._id.$id,
                [field]: row[field] || ''
            }).then(() => {
                this.$message.success('Date updated successfully')
                this.$set(row, dateType === 'start' ? '_editingStartDate' : '_editingEndDate', false)
            }).catch(() => {
                this.$message.error('Failed to update date')
            })
        },
        enterBatchEditMode() {
            this.batchEditMode = true
            this.batchSelectedRows = []
        },
        exitBatchEditMode() {
            this.batchEditMode = false
            this.batchSelectedRows = []
        },
        handleSelectionChange(selection) {
            this.batchSelectedRows = selection
        },
        batchSetDate(type) {
            if (this.batchSelectedRows.length === 0) {
                this.$message.warning('Please select at least one student')
                return
            }
            this.batchDateType = type
            this.batchDateValue = ''
            this.showBatchDateDialog = true
        },
        async confirmBatchDate() {
            if (!this.batchDateValue) {
                this.$message.warning('Please select a date')
                return
            }
            // Validate: end date must not be earlier than start date
            const field = this.batchDateType === 'start' ? 'membership_start' : 'membership_end'
            const hasConflict = this.batchSelectedRows.some(row => {
                if (this.batchDateType === 'end' && row.membership_start && this.batchDateValue < row.membership_start) {
                    return true
                }
                if (this.batchDateType === 'start' && row.membership_end && this.batchDateValue > row.membership_end) {
                    return true
                }
                return false
            })
            if (hasConflict) {
                this.$message.warning('End Date cannot be earlier than Start Date for some selected students')
                return
            }
            try {
                const promises = this.batchSelectedRows.map(row =>
                    postRequest('updateClubStudentMembership', {
                        club_user_id: row._id.$id,
                        [field]: this.batchDateValue
                    })
                )
                await Promise.all(promises)
                // Update local data
                this.batchSelectedRows.forEach(row => {
                    this.$set(row, field, this.batchDateValue)
                })
                this.$message.success(`${this.batchDateType === 'start' ? 'Start' : 'End'} date updated for ${this.batchSelectedRows.length} student(s)`)
                this.showBatchDateDialog = false
            } catch (err) {
                this.$message.error('Failed to update dates')
            }
        }
    }
}
</script>
<style scoped lang="scss">
.club_name {
    margin-left: 10px;
    color: #333;
    font-size: 20px;
}

::v-deep  .el-table .custom-row-bg {
    // background: #FF8833;
}

::v-deep  .el-table .custom-head-cell {
    background: #FF8833;
    color: white;
    // text-align: center;
    // border: 1px solid white;
    box-sizing: border-box;
    font-family: GravityBold;
}

.el-dropdown-link i {
    transform: rotate(90deg);  /* This will make the horizontal dots vertical */
}

.role-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #c0c4cc;
    font-size: 12px;
    line-height: 18px;
    color: #909399;
    font-weight: 500;
}
.role-tag--leader {
    border-color: #FF8833;
    color: #FF8833;
}
.role-tag--member {
    border-color: #c0c4cc;
    color: #909399;
}
</style>